(() => {
  const root = document.documentElement;
  const tiktokSessionKey = 'grada90_tiktok_session';
  let revealTimer;
  let stickyObserver;
  let rootObserver;
  let revealed = false;

  const isTikTokVisit = () => {
    const parameters = new URLSearchParams(window.location.search);
    const sourceParameters = ['utm_source', 'utm_medium', 'source'];
    if (sourceParameters.some((name) => (parameters.get(name) || '').toLowerCase().includes('tiktok'))) return true;

    for (const key of parameters.keys()) {
      if (/^(ttclid|tt_campaignid|tt_adid|tt_adgroupid|tt_pixel_id|tiktok_)/i.test(key)) return true;
    }
    return false;
  };

  const isFootballTeamsView = () => {
    const path = window.location.pathname.replace(/\/$/, '').toLowerCase();
    const view = new URLSearchParams(window.location.search).get('view');
    return path === '/collections/futbol' && (view || '').toLowerCase() === 'equipos';
  };

  let isTikTokSession = isTikTokVisit();
  try {
    if (isTikTokSession) {
      window.sessionStorage.setItem(tiktokSessionKey, '1');
    } else {
      isTikTokSession = window.sessionStorage.getItem(tiktokSessionKey) === '1';
    }
  } catch (_error) {
    // URL detection still works when session storage is unavailable.
  }

  const compactContext = isTikTokSession || isFootballTeamsView();
  const revealStorageKey = isTikTokSession
    ? 'grada90_tiktok_banner_revealed'
    : 'grada90_football_teams_banner_revealed';

  if (!compactContext) {
    delete root.dataset.gradaCookieSource;
    delete root.dataset.gradaCookieCompact;
    root.classList.remove('grada-cookie-delay-active', 'grada-cookie-banner-ready');
    root.style.removeProperty('--grada-cookie-sticky-offset');
    return;
  }

  root.dataset.gradaCookieSource = isTikTokSession ? 'tiktok' : 'football-teams';
  root.dataset.gradaCookieCompact = 'true';
  root.classList.add('grada-cookie-delay-active');

  const compactNativeCopy = () => {
    const banner = document.querySelector('#shopify-pc__banner, .shopify-pc__banner__dialog');
    if (!banner) return false;

    const message = banner.querySelector('p');
    if (message && message.dataset.gradaCompactCopy !== 'true') {
      const nativeLink = message.querySelector('a');
      const informationLink = document.createElement('a');
      informationLink.href = nativeLink?.href || '/pages/politica-de-cookies';
      informationLink.textContent = 'Más información';
      message.replaceChildren(
        document.createTextNode(
          'Usamos cookies para mejorar tu experiencia. Aceptar: cookies opcionales. Rechazar: solo esenciales. '
        ),
        informationLink
      );
      message.dataset.gradaCompactCopy = 'true';
    }

    const preferencesButton = banner.querySelector('#shopify-pc__banner__btn-manage-prefs');
    if (preferencesButton && preferencesButton.textContent.trim() !== 'Configurar') {
      preferencesButton.textContent = 'Configurar';
    }
    return Boolean(message && preferencesButton);
  };

  const observeNativeBanner = () => {
    compactNativeCopy();
    const bannerObserver = new MutationObserver(() => {
      compactNativeCopy();
    });
    bannerObserver.observe(document.documentElement, { childList: true, subtree: true });
    window.setTimeout(() => bannerObserver.disconnect(), 15000);
  };

  const updateStickyOffset = () => {
    const stickyBar = document.querySelector('.mobile-product-bar');
    const stickyVisible =
      window.matchMedia('(max-width: 749px)').matches &&
      stickyBar &&
      !stickyBar.hidden &&
      root.classList.contains('mobile-product-sticky-visible') &&
      stickyBar.getClientRects().length > 0;

    if (stickyVisible) {
      root.style.setProperty('--grada-cookie-sticky-offset', `${Math.ceil(stickyBar.getBoundingClientRect().height)}px`);
    } else {
      root.style.removeProperty('--grada-cookie-sticky-offset');
    }
  };

  const stopRevealListeners = () => {
    window.clearTimeout(revealTimer);
    window.removeEventListener('scroll', revealBanner);
  };

  const revealBanner = () => {
    if (revealed) return;
    revealed = true;
    root.classList.add('grada-cookie-banner-ready');
    stopRevealListeners();
    updateStickyOffset();

    try {
      window.sessionStorage.setItem(revealStorageKey, '1');
    } catch (_error) {
      // Presentation state is optional; consent remains entirely with Shopify.
    }
  };

  const wasRevealedThisSession = () => {
    try {
      return window.sessionStorage.getItem(revealStorageKey) === '1';
    } catch (_error) {
      return false;
    }
  };

  const startRevealTimer = () => {
    revealTimer = window.setTimeout(revealBanner, 5000);
  };

  const observeStickyBar = () => {
    const stickyBar = document.querySelector('.mobile-product-bar');
    stickyObserver?.disconnect();
    if (stickyBar && 'ResizeObserver' in window) {
      stickyObserver = new ResizeObserver(updateStickyOffset);
      stickyObserver.observe(stickyBar);
    }

    rootObserver = new MutationObserver(updateStickyOffset);
    rootObserver.observe(root, { attributes: true, attributeFilter: ['class'] });
    updateStickyOffset();
  };

  if (wasRevealedThisSession()) {
    revealBanner();
  } else {
    window.addEventListener('scroll', revealBanner, { passive: true, once: true });
    if (document.readyState === 'complete') {
      startRevealTimer();
    } else {
      window.addEventListener('load', startRevealTimer, { once: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      observeStickyBar();
      observeNativeBanner();
    }, { once: true });
  } else {
    observeStickyBar();
    observeNativeBanner();
  }

  window.addEventListener('resize', updateStickyOffset, { passive: true });
  window.addEventListener('orientationchange', updateStickyOffset, { passive: true });
})();
